import { createSlice } from "@reduxjs/toolkit"

const initialState = {
    title: '',
    author: '',
    onlyFavorite: false,
}

const filterSlice = createSlice({
  name: "filter",
  initialState: initialState,
  reducers: {
    setTitleFilter: (state, action) => {
      // Для slice можно просто изменять состояние благодоря встроенной библиотеке Immer
      state.title = action.payload;
      // Можно использовать и традиционноую перезапись на новый объект
      //   return {...state, title: action.payload}
    },
    setAuthorFilter: (state, action) => {
        state.author = action.payload;
    },
    setOnlyFavoriteFilter: (state) => {
        state.onlyFavorite = !state.onlyFavorite
    },
    resetFilters: () => {
        return initialState;
    }
  },
});

export const  { setTitleFilter, setAuthorFilter,setOnlyFavoriteFilter, resetFilters } = filterSlice.actions

export const selectTitleFilter = (state) => state.filter.title; // фнукция селектор для использования в useSelect
export const selectAuthorFilter = (state) => state.filter.author; // фнукция селектор для использования в useSelect
export const selectOnlyFavoriteFilter = (state) => state.filter.onlyFavorite; // фнукция селектор для использования в useSelect

export default filterSlice.reducer